import { SeverityLabelPipe } from '../pipes/SeverityLabelPipe';
import { StatusLabelPipe } from '../pipes/StatusLabelPipe';

export const FilterTypesEnum = Object.freeze({
    Type: 'type',
    Severity: 'severity',
    Status: 'status'
});

export const getFilterLabel = (key, value, TypeLabelPipe) => {
    switch (key) {
        case FilterTypesEnum.Type:
            return TypeLabelPipe && TypeLabelPipe(value);
        case FilterTypesEnum.Severity:
            return SeverityLabelPipe(value);
        case FilterTypesEnum.Status:
            return StatusLabelPipe(value);
        default:
            return null;
    }
};
